import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";
const borderColor = '#f4f4f4'

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 10,
    // borderColor: borderColor,
    // borderBottomWidth: 1,
    
  },
  tableLeft: {
    display: 'table',
    width: '50%',
    marginRight: 5,
    borderStyle: 'solid',
    // borderWidth: .5,
    borderRightWidth: 0,
    borderColor: '#d1d5db',
  },
  tableRight: {
    display: 'table',
    width: '50%',
    marginLeft: 5,
    borderStyle: 'solid',
    borderWidth: 0,
    borderLeftWidth: 0,
    borderColor: '#F5F5F5', 
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColLabel: {
    width: '40%',
    backgroundColor: '#F5F5F5', 
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#EEEEEE',
    padding: 6,
    // fontWeight: 'bold',
  },
  tableColValue: {
    width: '60%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#F5F5F5',
    padding: 6,
  },
  tableCell: {
    fontSize: 9,
    // color: '#374151', 
  },
});

const AgentName = ({ invoice }) => {
  const invoiceObj = JSON.parse(JSON.parse(JSON.stringify(invoice)));
  const client = invoiceObj.child[0];
  const agent = invoiceObj.agentdetails;

  return (
    <Fragment>
      <View style={styles.titleContainer}>
        {/* Left Table */}
        <View style={styles.tableLeft}>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Reference No</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}><b>{invoiceObj.booking_refrence_id}</b></Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Date Of Booking</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}><b>{moment(invoiceObj.b_date).format("D MMM Y")}</b></Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Total Amount</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}><b>{invoiceObj.paid_amount.toFixed(2)}</b></Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Client Name</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}><b>{client.first_name} {client.last_name}</b></Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Mobile No.</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}><b>{client.contact_number}</b></Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Email ID</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}><b>{client.email}</b></Text></View>
          </View>
        </View>

        {/* Right Table */}
        <View style={styles.tableRight}>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Agent Name</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}>{agent.corporate_name}</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Contact Person</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}>{agent.first_name} {agent.last_name}</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Mobile No.</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}>{agent.mobile_number}</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}><Text style={styles.tableCell}>Email ID</Text></View>
            <View style={styles.tableColValue}><Text style={styles.tableCell}>{agent.email}</Text></View>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default AgentName;
